import { Router } from '@angular/router';
import { IpAddress } from '../../Model/IpAddresses';
import { ToastsManager } from 'ng2-toastr';
import { CompteServer } from '../../Model/CompteServer';
import { ServiceAdminService } from '../../Providers/service-admin.service';
import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { IMyOptions } from 'mydatepicker';
import { Headers, RequestOptions } from '@angular/http';

/**
 * created by AHMED HAYEL
 * 
 */

@Component({
  selector: 'app-comptes-server',
  templateUrl: './comptes-server.component.html',
  styleUrls: ['./comptes-server.component.css']
})
export class ComptesServerComponent implements OnInit {
  comptesServer: CompteServer[];
  selectedCompteServer: CompteServer = new CompteServer();
  ips: IpAddress[] = [];
  public maxSize: number = 5;
  public bigTotalItems: number = 175;
  public bigCurrentPage: number = 1;
  public numPages: number = 0;
  itemsPerPage = 15;
  keyWord: string = "";
  private myDatePickerOptions: IMyOptions = {
    dateFormat: 'dd-mm-yyyy',
  };
  dt: Object;
  constructor(public toastr: ToastsManager, vcr: ViewContainerRef, private service: ServiceAdminService, private router: Router) {
    this.toastr.setRootViewContainerRef(vcr);
  }

  ngOnInit() {
    if (this.service.isAuthenticated == false) {
      this.router.navigate(['/error']);
    } else {
      this.getAllcompteServer(this.keyWord, this.bigCurrentPage - 1, this.itemsPerPage);
      this.ips = this.service.ips;
    }
  }

  //=====================================
  //     selected server account 
  //=====================================

  onSelect(compteServer: CompteServer) {
    this.selectedCompteServer = compteServer;

    console.log(this.selectedCompteServer.date_Expiration);
    let dateDecop = new Date(this.selectedCompteServer.date_Expiration);

    this.dt = {
      date: { year: dateDecop.getFullYear(), month: dateDecop.getUTCMonth() + 1, day: dateDecop.getUTCDate() }
    };
    this.dt['jsdate'] = dateDecop;
    console.log("am her : " + dateDecop.getUTCDate());
  }

  //=====================================
  //     Get All server account 
  //     by keyword or not  
  //=====================================

  getAllcompteServer(keyWord: string, page: number, size: number) {

    this.service.getAllServerCompte(keyWord, page, size).subscribe(_comptesServer => {
      this.comptesServer = _comptesServer.content;
      for (let i = 0; i < this.comptesServer.length; i++) {
        if (new Date().getTime() < new Date(this.comptesServer[i].date_Expiration).getTime()) {

          this.comptesServer[i].expired = false;
          this.comptesServer[i].during = true;
        } else {
          this.comptesServer[i].expired = true;
          this.comptesServer[i].during = false;
        }
      }
      this.bigTotalItems = _comptesServer.totalElements;
    });
  }

  //=====================================
  //    Search server account 
  //=====================================

  searchAccount() {
    this.bigCurrentPage = 1;
    this.getAllcompteServer(this.keyWord, this.bigCurrentPage - 1, this.itemsPerPage);
  }

  //=====================================
  //    Change page 
  //=====================================

  public pageChanged(event: any): void {
    this.bigCurrentPage = event.page;
    this.getAllcompteServer(this.keyWord, this.bigCurrentPage - 1, this.itemsPerPage);
  }

  //=======================================
  //    Delete server account with boitiers
  //=======================================

  deleteCompteServer() {
    let res = confirm("are you sure that you want to delete this Account ?");
    if (res) {
      let indexCompte: number = 0;
      indexCompte = this.comptesServer.findIndex(x => x.idCompteClientServer == this.selectedCompteServer.idCompteClientServer);

      this.service.deleteCompteServer(this.selectedCompteServer.idCompteClientServer);
      this.comptesServer.splice(indexCompte, 1);
      this.toastr.success(' Account was deleted ', 'Success!')
    } else {
      this.toastr.error(' Account was not deleted ', 'Error!')
    }

  }

  //=======================================
  //   Update server account
  //=======================================

  updateCompteServer() {
    console.log(this.dt['jsdate']);
    let myDate = new Date(this.dt['jsdate']);
    if (myDate.getUTCHours() == 23) {
      console.log(myDate.getHours());
      myDate.setHours(myDate.getHours() + 1);
    }
    console.log("simple hours : " + myDate);

    this.selectedCompteServer.date_Expiration = myDate.getTime();
    console.log(this.selectedCompteServer.date_Expiration);

    this.service.updateServerCompte(this.selectedCompteServer.idCompteClientServer, this.selectedCompteServer).subscribe(_compteUp => {
      if (new Date().getTime() < _compteUp.date_Expiration) {
        _compteUp.expired = false;
        _compteUp.during = true;
      } else {
        _compteUp.expired = true;
        _compteUp.during = false;
      }
      let index: number = 0
      index = this.comptesServer.findIndex(x => x.idCompteClientServer == _compteUp.idCompteClientServer);
      this.comptesServer.splice(index, 1, _compteUp);
      this.toastr.success(' Server account updated ', 'Success!')
    }, error => this.toastr.error(' There are mistake here ', 'Error!'));
    this.selectedCompteServer = new CompteServer();
  }
  addZero(i) {
    return (i < 10) ? "0" + i : "" + i;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin-component/comptes-server/comptes-server.component.ts